import { useEffect, useState } from "react";
import axios from "axios";
import { Clock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SlotPicker = ({ date, value, onChange, labels, refreshKey = 0 }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!date) {
      setData(null);
      return;
    }
    axios.get(`${API}/slots`, { params: { date } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [date, refreshKey]);

  if (!date) {
    return <p className="rounded-xl bg-mint px-4 py-3 text-sm text-brand" data-testid="slot-hint">{labels.timeHint}</p>;
  }
  if (data?.closed) {
    const msg = data.reason === "sunday" ? labels.timeClosed : `${labels.timeClosedDay}${data.reason && data.reason !== "closed" ? ` (${data.reason})` : ""}.`;
    return <p className="rounded-xl bg-cream px-4 py-3 text-sm font-semibold text-gold" data-testid="slot-closed">{msg}</p>;
  }
  if (!data) return null;
  const available = data.slots.filter((s) => s.available);
  if (available.length === 0) {
    return <p className="rounded-xl bg-cream px-4 py-3 text-sm text-gold" data-testid="slot-none">{labels.timeNone}</p>;
  }

  return (
    <div className="grid grid-cols-3 gap-2 sm:grid-cols-5" data-testid="slot-picker">
      {data.slots.map((s) => {
        const selected = value === s.time;
        return (
          <button
            key={s.time}
            type="button"
            disabled={!s.available}
            onClick={() => onChange(selected ? "" : s.time)}
            data-testid={`slot-${s.time.replace(":", "")}`}
            className={`flex items-center justify-center gap-1.5 rounded-xl border px-2 py-2.5 font-mono text-xs transition-all ${
              !s.available
                ? "cursor-not-allowed border-brand/10 bg-mint/50 text-brand/40 line-through"
                : selected
                ? "border-gold bg-gold text-white shadow-lg shadow-gold/25"
                : "border-brand/20 bg-white text-forest hover:border-brand hover:bg-mint"
            }`}
            title={!s.available ? labels.timeTaken : s.time}
          >
            <Clock className="h-3 w-3" />
            {s.time}
          </button>
        );
      })}
    </div>
  );
};

export default SlotPicker;
